export default __webpack_public_path__ + "static/media/iconShareWheel.2d0c3884.svg";